import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Button, Typography } from "@mui/material";
import { Facebook, Instagram, LinkedIn, X } from "@mui/icons-material";
import { Link } from "react-router-dom";

const WaveWrapper = styled("div")({
  bottom: 0,
  left: 0,
  width: "100%",
  overflow: "hidden",
  zIndex: 1, // Behind content
});

const WaveSvg = styled("svg")({
  position: "relative",
  display: "block",
  width: "calc(100% + 1.3px)",
});

const CustomIcons = ({ Icon, url }) => {
  return (
    <Link href={url} target="_blank">
      <Icon
        sx={{
          p: 1,
          fontSize: "1.5rem",
          color: "#242424",
          border: "2px solid #242424",
          borderRadius: "50%",
          "&:hover": { bgcolor: "#242424", color: "#ffdd24" },
        }}
      />
    </Link>
  );
};

function ComingSoon() {
  const socialIcons = [
    {
      icon: Facebook,
      url: "https://www.facebook.com/profile.php?id=61577974327033",
    },
    {
      icon: Instagram,
      url: "https://www.instagram.com/datapi_reaserch/",
    },
    {
      icon: LinkedIn,
      url: "https://www.linkedin.com/company/datapiresearch/",
    },
    {
      icon: X,
      url: "https://x.com/datapi_research",
    },
  ];

  return (
    <WaveWrapper>
      <Box sx={{ width: "100%", color: "#242424" }}>
        <Box
          sx={{
            pt: { xs: 22, md: 18 },
            pb: { xs: 22, md: 8 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ fontSize: { xs: "2.8rem", md: "4.5rem" }, fontWeight: "900" }}
          >
            Coming Soon
          </Typography>
          <Typography sx={{ fontSize: { xs: "1.4rem", md: "2.2rem" } }}>
            Stay Tuned
          </Typography>
          <Link to="/contact">
            <Button
              variant="outlined"
              sx={{
                mt: 7,
                color: "#55d6aa",
                bgcolor: "#242424",
                borderColor: "#55d6aa",
              }}
            >
              Contact us
            </Button>
          </Link>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 3,
              gap: 3,
            }}
          >
            {socialIcons.map((socialIcon, index) => (
              <CustomIcons
                key={index}
                Icon={socialIcon.icon}
                url={socialIcon.url}
              />
            ))}
          </Box>
        </Box>
      </Box>

      <WaveSvg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,64L60,85.3C120,107,240,149,360,149.3C480,149,600,107,720,74.7C840,43,960,21,1080,42.7C1200,64,1320,128,1380,160L1440,192L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          fill={"#55d6aa"}
        />
      </WaveSvg>
    </WaveWrapper>
  );
}

export default ComingSoon;
